import component from './packet-card.component';

export default angular
  .module('fizyweb.paycell.packetcard', [])
  .component('fizyPaycellPacketCard', component).name;



// WEBPACK FOOTER //
// src/app/components/packet-card/packet-card.module.ts